import { Model } from '@vuex-orm/core'
import QuestionOption from './../question-options/model'
import { MODE_EXAM, MODE_TRAINING } from '../tests/model'
import {map, orderBy, get, find, filter} from 'lodash'

export const TYPE_MULTIPLE = 'multiple'
export const TYPE_SINGLE = 'single'
export const TYPE_MULTIPLE_SEQUENCE = 'multiple-sequence'
export const TYPE_SINGLE_SEQUENCE = 'single-sequence'

export default class Question extends Model {
    static get entity () {
        return 'questions'
    }

    static fields () {
        return {
            id: this.uid(),
            question: this.string(''),
            imageUrl: this.string(null).nullable(),
            answerType: this.string(''),
            activityId: this.uid(),
            isRightAnswer: this.boolean(),
            answer: this.attr(),
            options: this.hasMany(QuestionOption, 'questionId'),
        }
    }

    get userOptions () {
        if (!this.answer) return []
        let answerOptions = this.answer

        return orderBy(
            filter(
                map(answerOptions, item => {
                    return find(this.options, opt => opt.id === item.optionId)
                }),
                item => !!item
            ), ['order'], ['asc'])
    }

}
